import { useEffect } from 'react';

export const useRefetchData = refetch => {
  useEffect(() => {
    refetch()
      .then(res => {
        return res;
      })
      .catch(err => {
        console.error('Refetch Appolo Error : ' + err.message);
      });
    return () => null;
  }, [refetch]);
};
